module.exports = __webpack_public_path__ + "img/thumbnail_Moose_m_albino.cae0aa04.png";